import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("g", null, [
              _createElementVNode("path", {
                fill: "currentColor",
                d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5c-4.694 0-8.5 3.806-8.5 8.5s3.806 8.5 8.5 8.5 8.5-3.806 8.5-8.5-3.806-8.5-8.5-8.5zm0 1c.414 0 .75.336.75.75v.835c1.501.342 2.625 1.687 2.625 3.29 0 .414-.336.75-.75.75s-.75-.336-.75-.75c0-1.034-.841-1.875-1.875-1.875s-1.875.841-1.875 1.875.841 1.875 1.875 1.875c1.861 0 3.375 1.514 3.375 3.375 0 1.603-1.124 2.948-2.625 3.29v.835c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-.835c-1.501-.342-2.625-1.687-2.625-3.29 0-.414.336-.75.75-.75s.75.336.75.75c0 1.034.841 1.875 1.875 1.875s1.875-.841 1.875-1.875S13.034 12.75 12 12.75c-1.861 0-3.375-1.514-3.375-3.375 0-1.603 1.124-2.948 2.625-3.29V5.25c0-.414.336-.75.75-.75z",
                transform: "translate(-1236 -440) translate(120 420) translate(1108 12) translate(8 8)"
              })
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }